/**
 * Wohin nach der Anmeldung.
 *
 * Eigenes Modul, weil das eine Sicherheitsfunktion ist und keine Anzeigelogik:
 * `weiter` kommt aus der Adresszeile und ist damit Eingabe eines Fremden. Ein
 * Ziel, das nach draussen zeigt, waere eine offene Weiterleitung — ein
 * Phishing-Werkzeug mit unserer Domain davor, und der Nutzer sieht bis zum
 * Klick nur 99takes.
 *
 * Die Regel ist bewusst eine Erlaubnisliste und keine Sperrliste: genau ein
 * fuehrender Schraegstrich, danach kein zweiter. Alles andere faellt auf den
 * Standard zurueck, auch Eingaben, an die hier niemand gedacht hat.
 *
 * DER STANDARD IST /runs, nicht /account (Robert, 29.09.2026: „soll /account
 * wirklich die startseite sein?“). Wer wiederkommt, will sehen, was seine
 * Runs ergeben haben; Guthaben und Plaene sind ein Reiter. Neue Konten
 * landen nach Fragen und Rundgang ohnehin auf /runs, und dessen leerer
 * Zustand zeigt dieselben drei Schritte wie „Loslegen“ auf /account.
 * Auch App.tsx (Startseite, Auffang, angemeldet auf /login), Bestaetigt.tsx
 * und die Wortmarke im Kopf nehmen diesen Wert.
 */

export const STANDARDZIEL = '/runs';

export function sicheresZiel(roh: string | null | undefined): string {
  if (!roh) return STANDARDZIEL;

  // "//example.com" ist eine schemarelative Adresse und fuehrt nach draussen.
  // "/\\example.com" ebenso: Browser behandeln den Backslash wie einen
  // Schraegstrich, viele Pruefungen tun es nicht.
  if (!roh.startsWith('/')) return STANDARDZIEL;
  if (roh.startsWith('//') || roh.startsWith('/\\')) return STANDARDZIEL;

  // Steuerzeichen und Leerraum am Anfang koennen eine Adresse verschieben,
  // bevor der Browser sie liest.
  if (/[ -]/.test(roh)) return STANDARDZIEL;

  return roh;
}
